import { sendPatientReferral } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { SendReferralRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import type { DocumentDraft } from '@/entities/document-draft';
import {
  documentBodyFromMarkdown,
  documentTitleFromMarkdown,
  type DocumentDraftAttachment,
} from '@/entities/document-draft';
import { createLotusRequestConfig } from '@/shared/api/lotus';

import type { ReferralRecipient } from '../model/referralRecipient';

export type SendReferralResponse = {
  id: string;
  direction: 'outbound';
  status: 'in_progress' | 'delivered' | 'failed';
};

function recipientPayload(recipient: ReferralRecipient): SendReferralRequestT['recipient'] {
  if (recipient.channel === 'metriport') {
    return { ...recipient.destination, channel: recipient.channel };
  }

  return { ...recipient.destination, channel: recipient.channel };
}

export async function sendReferral(
  patientId: string,
  draft: DocumentDraft,
  recipient: ReferralRecipient,
  signal?: AbortSignal
): Promise<SendReferralResponse> {
  const config = await createLotusRequestConfig({ signal });
  const response = await sendPatientReferral(
    patientId,
    {
      send_id: draft.id,
      recipient: recipientPayload(recipient),
      subject: documentTitleFromMarkdown(draft.content.bodyMarkdown),
      body: documentBodyFromMarkdown(draft.content.bodyMarkdown),
      attachment_ids: draft.content.attachments.map(
        ({ attachmentId }: DocumentDraftAttachment) => attachmentId
      ),
    },
    config
  );
  const parsed = lotusHealthZod.sendPatientReferralResponse.parse(response.data);
  return {
    id: parsed.id,
    direction: parsed.direction,
    status: parsed.status,
  };
}
